import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import moment from 'moment';
import loginHeaderImage from '../../../assets/images/login-header.png';
import OtpSpace from "./../../../assets/icons/otp-space.png";
import downloadApp from './../../../assets/images/downloadApp.svg';
import keyGif from './../../../assets/images/key.gif';
import logo from "./../../../assets/images/logo1.png";
import ShopIcon from './../../../assets/images/ShopIcon.png';
import FooterContact from '../FooterContact';
const CryptoJS = require("crypto-js");

const StepTwo = () => {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [email, setEmail] = useState("");


    let navigate = useNavigate();
    const [timer, setTimer] = useState(process.env.REACT_APP_RESEND_OTP_TIMER ?? 60);

    const [currentData, setCurrentData] = useState({
        email: "",
        otp: "",
        expire: ""
    })

    useEffect(() => {

        // Check OTP page access is valid or not
        let is_valid_request = window.localStorage.getItem("fp");
        if (is_valid_request === null || is_valid_request === undefined || is_valid_request === "") {
            navigate("/forget-password-step-one");
            return;
        }

        let is_valid_request_core = JSON.parse(CryptoJS.AES.decrypt(is_valid_request, process.env.REACT_APP_SECURITY_SALT).toString(CryptoJS.enc.Utf8));
        const now = moment().add(1, "Minutes").format("YYYY-MM-DD HH:mm:ss");
        if (is_valid_request_core?.expire < now) {
            window.localStorage.clear();
            toast.error("OTP time expire !");
            return navigate("/forget-password-step-one");
        }


        setCurrentData(is_valid_request_core);
        if (isLoaded === true) {
            if (error) {
                toast.error(error.messages.toString());
                return;
            }

            let response = JSON.stringify(apiData);
            response = JSON.parse(response);
            if (response["code"] === 200) {
                return;
            }

            toast.error(response["messages"].toString());
        }
    }, [apiData, isLoaded]);


    // Timer
    useEffect(() => {
        if (timer <= 0) {
            $("#resetOtpBtn").hide();
            $("#resetOtpBtnActive").show();
        };

        const timerInterval = setInterval(() => {
            setTimer(timer - 1);
        }, 1000);

        return () => clearInterval(timerInterval);
    }, [timer]);


    var handleChange = (element, index) => {
        if (isNaN(element.value)) {
            return false;
        }

        setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

        if (element.value !== "" && element.parentNode.nextSibling) {
            element.parentNode.nextSibling.querySelector("input").focus();
        }

        if (element.value === "" && element.parentNode.previousSibling) {
            element.parentNode.previousSibling.querySelector("input").focus();
        }
    }



    var handleSubmit = async (event) => {
        event.preventDefault();
        var otpString = otp.join('');
        if (otpString?.length === 6) {
            await fetch(process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_PREFIX + "panel/forget-password/check-otp", {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify({
                    email_address: currentData.email,
                    otp: otpString
                })
            }).then(res => res.json()).then(
                (resultJSON) => {
                    var result = JSON.stringify(resultJSON);
                    result = JSON.parse(result);

                    if (result["code"] === 200) {
                        navigate("/forget-password-step-three", {
                            state: {
                                email_address: email,
                                otpNumber: otp
                            }
                        });
                        return;
                    }

                    toast.error(result["messages"].toString());
                    return;
                },
                (error) => {
                    console.log(error.messages);
                }
            );

            return;
        }

        toast.error("Please enter valid OTP");
    }

    var resendOtp = () => {
        try {
            fetch(process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_PREFIX + "panel/forget-password/check-email", {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify({
                    email_address: currentData.email,
                })
            }).then(res => res.json()).then(
                (resultJSON) => {
                    var result = JSON.stringify(resultJSON);
                    result = JSON.parse(result);

                    if (result["code"] === 200) {
                        $("input").val("");

                        $("#resetOtpBtnActive").attr("disabled", "disabled");
                        $("#resetOtpBtnActive").addClass("text-ash");
                        toast.success(result["messages"].toString());
                        setTimeout(() => {
                            document.location.reload();
                        }, 3000);

                        return;
                    }

                    toast.error(result["messages"].toString());
                },
                (error) => {
                    console.log(error.messages);
                    toast.error("A problem occur. Please try again.");
                }
            );
        } catch (ex) {
            console.log(ex.messages.toString());
            toast.error("A problem occur. Please try again.");
        }
    }


    // Button opacity control on input filled

    $("input[type='text']").on("input", function () {
        canChangeColor();
    });


    function canChangeColor() {

        var can = true;

        $("input[type='text']").each(function () {
            if ($(this).val() === '') {
                can = false;
            }
        });

        if (can) {
            $('.btn').css({ opacity: '1' });
            $('.btn').attr("disabled", false);
        } else {
            $('.btn').css({ opacity: '0.6' });
            $('.btn').attr("disabled", true);
        }
    }

    return (
        <section className="h-screen bg-white font-murecho">
            <ToastContainer />
            <div className="h-full justify-center">
                {/* <!-- Left column container with background--> */}


                <div className='flex justify-center'>
                    <img src={logo} alt="" className='absolute top-12' />
                </div>


                <div
                    className="g-6 flex h-full flex-wrap items-center justify-center lg:justify-center">
                    <div
                        className="shrink-1 mb-12 grow-0 basis-auto md:mb-0 ">
                        <img
                            src={ShopIcon}
                            className="hidden mb-10 lg:block"
                            alt="ShareTrip Partner Portal" />
                    </div>

                    {/* <!-- Right column container --> */}
                    <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">

                        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">

                            <div className="w-full bg-[#1882FF] rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
                                <div className="p-6 sm:p-10">

                                    <p className='text-white text-xl'>Welcome to</p>

                                    <p className="text-xl mb-4 font-semibold leading-8 text-white md:text-[28px] dark:text-white">
                                        ShareTrip Partner Portal
                                    </p>

                                    <p className='text-white font-medium text-sm mb-6'>OTP has been send on your given email address</p>

                                    <form onSubmit={handleSubmit}>
                                        <div className="flex justify-between items-center space-x-2 container mb-5">
                                            {otp.map((data, index) => {
                                                return (
                                                    <span className='flex justify-center items-center' key={index}>
                                                        <input
                                                            type="text"
                                                            name="otp[]"
                                                            maxLength="1"
                                                            key={index}
                                                            value={data}
                                                            className="w-[45.17px] h-[60px] border border-solid border-[#EEEEEE] rounded-lg text-center"
                                                            onChange={(e) => {
                                                                handleChange(e.target, index);
                                                            }}
                                                            onFocus={(e) => e.target.select()}
                                                            required
                                                        />
                                                        {((index + 1) % 2 === 0 && index < (otp.length - 1)) && (<img alt="OTP Space" src={OtpSpace} className="h-[2px] w-[9px] ml-[10px] mr-0"></img>)}
                                                    </span>
                                                );
                                            })}
                                        </div>

                                        <button className="btn w-full mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-60">Next</button>

                                        
                                        <div className='flex justify-between'>
                                            <Link to={"/"} className='text-white text-sm text-left font-semibold'>
                                                Back to login
                                            </Link>
                                            <p className='text-white text-sm text-right float-right'>
                                                Didn't get OTP?
                                                <button id="resetOtpBtn" type="button" className="text-[#BECAD6] font-medium ml-2 cursor-default">Resend in <strong id="counter">{timer}</strong> seconds</button>

                                                <button id="resetOtpBtnActive" onClick={resendOtp} type="button" className="hidden font-medium text-white ml-1">
                                                    Resend
                                                </button>
                                            </p>
                                        </div>
                                        

                                    </form>
                                </div>
                            </div>

                            <FooterContact />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default StepTwo;